<style lang="sass" scoped>
.form-inline .timepicker {
  display: inline-block;
  width: auto;
  vertical-align: middle;
}
</style>


<template>
<div id="timepicker-{{ _uid }}" class="timepicker">
  <label v-if="label" for="timepicker-select-{{ _uid }}">{{ label }}</label>
  <select id="timepicker-select-{{ _uid }}" class="form-control" v-model="value" :disabled="disabled">
    <option v-for="(value, text) in timeOptions" :value="value" :selected="">{{ text }}</option>
  </select>
</div>
</template>


<script>
import moment from 'moment'

export default {
  name: 'ui-timepicker',
  props: {
    value: {
      type: String,
      default: null,
      twoWay: true,
    },
    startAt: {
      type: String,
      default: '00:00',
    },
    endAt: {
      type: String,
      default: '24:00',
    },
    stepInMinutes: {
      type: Number,
      default: 10,
    },
    excludeEnd: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    timeOptions() {
      let options = {}

      let range = moment.range(moment(this.startAt, 'HH:mm'), moment(this.endAt, 'HH:mm'))
      let duration = moment.duration(this.stepInMinutes, 'minutes')
      range.by(duration, t => {
        options[t.format('HH:mm')] = t.format('HH:mm')
      }, this.excludeEnd)

      if (this.value && !options[this.value] ) {
        options[this.value] = this.value
      }

      return options
    },
  },
}
</script>



// WEBPACK FOOTER //
// timepicker.vue?478a7700